import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'; // <--- Import Location
import { SharedEarningsService } from './../../../shared-earnings.service';
import { ApiService } from 'src/app/shared/services';

import { PaymentMethodViewTypeEnum } from 'src/app/shared/partials/system-payment-method-view/system-payment-method-view.component';
import { Payment_Gateway_Enum } from 'src/app/models/portal';
import { SalesLogDetailedElement } from 'src/app/models/system-earnings';
import {
  BrowserNameEnum,
  DeviceTypeEnum,
  OperatingSystemEnum,
} from 'src/app/models/dashboard.shared';

@Component({
  selector: 'app-sales-item-view',
  templateUrl: './sales-item-view.component.html',
  styleUrls: ['./sales-item-view.component.css'],
})
export class SalesItemViewComponent implements OnInit {
  // Enums
  readonly browserNameEnum = BrowserNameEnum;
  readonly deviceTypeEnum = DeviceTypeEnum;
  readonly operatingSystemEnum = OperatingSystemEnum;
  readonly paymentMethodViewTypeEnum = PaymentMethodViewTypeEnum;
  readonly salesPaymentMethodEnum = Payment_Gateway_Enum;

  // State
  saleItem: SalesLogDetailedElement | any = null;
  isLoading: boolean = true;
  hasError: boolean = false;
  isCopied: boolean = false;

  private _inputId: number;

  @Input('itemId') set saleItemId(id: number) {
    if (id) {
      this._inputId = id;
      this.loadData(id);
    }
  }

  constructor(
    public api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    public sharedEarningsService: SharedEarningsService,
    private _location: Location // <--- Inject Location
  ) {}

  ngOnInit() {
    if (!this._inputId) {
      this.route.params.subscribe((params) => {
        const id = params['id'];
        if (id) this.loadData(id);
      });
    }
  }

  // <--- Add Back Function
  goBack() {
    this.router.navigate(['/dashboard/earnings/sales']);
  }

  copyToClipboard(text: string) {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    });
  }

  loadData(id: number) {
    this.isLoading = true;
    this.hasError = false;

    this.api.getSaleItemById(id).subscribe({
      next: (data) => {
        this.saleItem = data;
        this.sharedEarningsService.currentSalesItem = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading sale item', err);
        this.isLoading = false;
        this.hasError = true;
      },
    });
  }
}
